import ConsumerRefService from "@api/consumer/consumerRefService";
import {GoalConditionType} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {useNavigate, useParams} from "react-router";
import withPage from "@components/hoc/withPage";
import {GoalConditionFormValues} from "../forms/conditionBaseInfoBlock";
import GoalConditionForm from "./goalConditionForm";


const AddConditionForm: FC = () => {

    const {goal_id} = useParams<{ goal_id: string }>();
    const navigate = useNavigate();

    const initialValues: GoalConditionFormValues = {
        name: '',
        donateValue: undefined,
        isActive: false,
        type: GoalConditionType.Manual
    };

    const onSubmit = useCallback(async (values: GoalConditionFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.putCondition(goal_id || '', values);

        if (result.success) {
            toastr.success("Создание условия", "Условие достижения успешно добавлено");
            navigate(`/consumer/goals/${goal_id}/conditions/${result.data.id}/`, { replace: true });
        }
        else {
            if (result.errorCode === 'GoalNotFound') {
                toastr.error('Создание условия', 'Достижение не найдено');
            }
            else if (result.errorCode === 'InvalidRequest') {
                toastr.error('Создание условия', 'Некорректные параметры условия');
            }
            else if (result.errorCode === 'InvalidType') {
                toastr.error('Создание условия', 'Некорректный тип условия');
            }
            else {
                toastr.error('Создание условия', 'Неизвестная ошибка');
            }
        }
    }, [goal_id, navigate]);

    return (
        <GoalConditionForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={false}
            title="Создание условия"
            cancelUrl={`/consumer/goals/${goal_id}/conditions/`}
        />
    )
}

export default withPage(AddConditionForm);
